__turbopack_context__.v({
  "shine": "shine-border-module__5VALUa__shine",
});
